import Model from '@/models/Model'

export default class SlSaleInvoice extends Model {

    /**
     * 
     */
    get details() {
      return this.sl_detail_sale_invoices || []
    }
  
    /**
     * 
     */
    set details(val) {
      return this.sl_detail_sale_invoices = val || []
    }

    /**
     * 
     */
    resource() {
        return 'sl_sale_invoice'
    }
}